import React from 'react';
import styled, { css } from 'styled-components';
import ImageSvg from './imageSvg';
import Lights from './lights';
import media from '../../base/media';
import StandingLampNightLights from './standingLampNightLights';
import RspImageBg from '../../base/images/rspImageBg';

const StyledWrapper = styled.div`
	${({ imageRightSideOnly }) => imageRightSideOnly && css`
		width: 60%;
	`}

	${({ imageRightSideOnly }) => !imageRightSideOnly && css`
		max-width: 192rem;
		margin: 0 auto;
	`}
	${media.desktopLarge`
		${({ imageRightSideOnly }) => imageRightSideOnly && css`
			width: 50%;
		`}
	`}
	${media.tabletOnly`
		width: 100%;
	`}
`;

const StyledImage = styled.div`
	position: relative;

	svg {
		width: 110rem;
		margin-left: -35rem;
	}

	${media.desktopSmall`
		svg {
			width: 1920px;
			max-width: 100%;
			height: 800px;
			margin: 0;
		}
	`}
`;

const StaticImage = css`
	background-position: 50% 10%;
	margin-bottom: 0;
	background-size: contain;
	background-repeat: no-repeat;
	background-color: white;
	background-position: center;
	width: 110rem;
	height: 100%;
	${media.desktopSmall`
		width: 1920px;
		max-width: 100%;
		height: 800px;
		margin: 0;
	`}
	${media.tabletOnly`
		width: 1920px;
		max-width: 100%;
		height: 300px;
		background-position: center;
	`}
`;

const Image = (props) => {
	const { imageUrl } = props;
	return (
		<StyledWrapper {...props}>
			{imageUrl ? (
				<StyledImage {...props}>
					<RspImageBg
						styles={StaticImage}
						image={imageUrl}
					/>
				</StyledImage>) : (
					<StyledImage>
						<StandingLampNightLights />
						<ImageSvg />
					</StyledImage>
			)}
			<Lights />
		</StyledWrapper>
	);
};

export default Image;
